import { render, staticRenderFns } from "./detail-info-v2.vue?vue&type=template&id=8f53ea9a&"
import script from "./detail-info-v2.vue?vue&type=script&lang=js&"
export * from "./detail-info-v2.vue?vue&type=script&lang=js&"
import style0 from "./detail-info-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports